import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ProgressBarLoaderContainer } from "./styled";
export var ELoaderThemes;
(function (ELoaderThemes) {
    ELoaderThemes["PRIMARY"] = "PRIMARY";
    ELoaderThemes["SECONDARY"] = "SECONDARY";
    ELoaderThemes["TERTIARY"] = "TERTIARY";
})(ELoaderThemes || (ELoaderThemes = {}));
export var EMessagePosition;
(function (EMessagePosition) {
    EMessagePosition["TOP"] = "TOP";
    EMessagePosition["BOTTOM"] = "BOTTOM";
    EMessagePosition["LEFT"] = "LEFT";
    EMessagePosition["RIGHT"] = "RIGHT";
})(EMessagePosition || (EMessagePosition = {}));
export const generateTheme = (loaderTheme, theme) => {
    let newTheme = theme.colorPalette.secondaryColor;
    switch (loaderTheme) {
        case ELoaderThemes.PRIMARY:
            newTheme = theme.colorPalette.primaryColor;
            break;
        case ELoaderThemes.SECONDARY:
            newTheme = theme.colorPalette.secondaryColor;
            break;
        case ELoaderThemes.TERTIARY:
            newTheme = theme.colorPalette.tertiaryColor;
            break;
    }
    return newTheme;
};
export const ProgressBarLoader = (_props) => {
    return (_jsx(ProgressBarLoaderContainer, { className: "custom-loader" }));
};
